<div *ngIf="is_translate" id="google_translate_element" style="background-color: #133282;">
</div>